import Typography from "@mui/material/Typography";

const Main = () => {
  return <Typography>Main page</Typography>;
};

export default Main;
